export type FleetSpecKey = 'mtow' | 'range' | 'wingspan' | 'length' | 'height' | 'passengers';

export type FleetAircraft = {
  id: string;
  nameKey: 'fleet.a300.name' | 'fleet.a310.name';
  image: string;
  specs: Record<FleetSpecKey, number>;
};

/** Published type figures for the two widebodies currently in the Soroush fleet. */
export const fleet: FleetAircraft[] = [
  {
    id: 'a300-600',
    nameKey: 'fleet.a300.name',
    image: '/images/hero-home.jpg',
    specs: {
      mtow: 171700,
      range: 7500,
      wingspan: 44.8,
      length: 53.8,
      height: 16.5,
      passengers: 280,
    },
  },
  {
    id: 'a310',
    nameKey: 'fleet.a310.name',
    image: '/images/hero-home.jpg',
    specs: {
      mtow: 153000,
      range: 9500,
      wingspan: 43.9,
      length: 46.6,
      height: 15.8,
      passengers: 210,
    },
  },
];

export const fleetSpecOrder: { key: FleetSpecKey; unit: 'kg' | 'km' | 'm' | 'pax'; digits: number }[] = [
  { key: 'mtow', unit: 'kg', digits: 0 },
  { key: 'range', unit: 'km', digits: 0 },
  { key: 'wingspan', unit: 'm', digits: 1 },
  { key: 'length', unit: 'm', digits: 1 },
  { key: 'height', unit: 'm', digits: 1 },
  { key: 'passengers', unit: 'pax', digits: 0 },
];
